export default "__VITE_ASSET__DFdHYXgB__"